// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__2VIX2","list_item":"styles_list_item__1mgtH","more":"styles_more__GD3-T"};